import * as React from "react"
import * as $ from "jquery"
import * as _ from "lodash"
import {IDoctorCheckInInfo} from "@curefit/care-common";
import { ChangeEvent } from "react" 
import TextInput from "../TextInput";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import {TypeAheadElement} from "../TypeAhead";
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import CustomSelect from "../CustomSelect";
import DurationComponent from "../DurationComponent";
import ModelFactory from "../../models/ModelFactory";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import AppUtils from "../../utils/AppUtils";
import {IReferral} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 25/06/18.
 */

export interface DoctorReferralItemEditorProps {
    item: IReferral;
    onDataChange: (update: IReferral) => any,
    fetchStaticDiseasesData?: (input: string) => Promise<IDiagnosticSuggestions[]>,
    staticSpecialities: any[],
    consultationType: string
}

export interface DoctorReferralItemEditorState {
    validate: boolean
}

class DoctorReferralItemEditor extends React.Component<DoctorReferralItemEditorProps, DoctorReferralItemEditorState> {
    private referralItemDOM: any;

    constructor(props: DoctorReferralItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.referralItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.referralItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onReferralChange = (value: string) => {
        let updatedItem = { ...this.props.item, doctorSpecialityCode: value };
        this.props.onDataChange(updatedItem);
    };

    onReferralTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, consultationType: event.target.checked ? AppConstants.ConsultationModes.INCENTRE.id : null }
        this.props.onDataChange(updatedItem);
    }

    onReferralReasonChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, comment: event.target.value };
        this.props.onDataChange(updatedItem);
    }

    onReferralWhenCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        let activityDate = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.when) ? this.props.item.when : ModelFactory.createNewFrequency();
        activityDate.count =  isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        activityDate.unit = _.isEmpty(activityDate.unit) ? null : activityDate.unit;
        let updatedItem = { ...this.props.item, activityDate };
        this.props.onDataChange(updatedItem);
    }

    onReferralWhenUnitChange = (value: string) => {
        let activityDate = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.when) ? this.props.item.when : ModelFactory.createNewFrequency();
        activityDate.unit = value;
        let updatedItem = { ...this.props.item, activityDate };
        this.props.onDataChange(updatedItem);
    }

    onReferralWhenChange = (elem: TypeAheadElement) => {
        let when = elem.others.value;
        let updatedItem = { ...this.props.item, when };
        this.props.onDataChange(updatedItem);
    }

    onReferralReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.item, remind: event.target.checked }
        this.props.onDataChange(updatedItem);
    }

    generateSpecialityList = (): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(this.props.staticSpecialities, (speciality) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = speciality.doctorTypeCode;
            staticDataItem.displayValue = speciality.displayText;
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    render() {
        // let isCancelled = !_.isEmpty(this.props.item) && this.props.item.status === AppConstants.planStatus.CANCELLED;
        // let isEditable = _.isEmpty(this.props.item.id);
        let specialist = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.doctorSpecialityCode) ? AppUtils.getSpecialityNameFromCode(this.props.item.doctorSpecialityCode, this.props.staticSpecialities) : null;
        // let isChecked = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.consultationType) ? this.props.item.consultationType === AppConstants.ConsultationModes.INCENTRE.id : false;
        let referralReason = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.comment) ? this.props.item.comment : "";
        let referralDays = !_.isEmpty(this.props.item) && !_.isEmpty(this.props.item.when) ? this.props.item.when.count : "" as any;
        let defaultSinceMonth = !_.isEmpty(this.props.item)
                                && !_.isEmpty(this.props.item.when)
                                && !_.isEmpty(this.props.item.when.unit) ?
                                    this.props.item.when.unit.toString() : null;
        // let reminderStatus = !_.isEmpty(this.props.item) ? this.props.item.remind : false;
        let referralItemValidationStatus = this.state.validate && _.isNull(specialist) ? "error" : "";
        return (
            <div className={`referral-item-editor`} ref={(referralItemDOM) => this.referralItemDOM = referralItemDOM}>
                {/*{hasExpired && <div className={"expired-text"}>*/}
                    {/*<span>EXPIRED</span>*/}
                {/*</div>}*/}
                <div className={`referral-editor-name ${referralItemValidationStatus}`}>
                    <CustomSelect dropdownValues={this.generateSpecialityList()} selectedValue={specialist} defaultValue={"Select"} updateDropdownValue={this.onReferralChange}/>
                </div>
                {/*<div className="referral-editor-type">*/}
                    {/*<input type="checkbox" onChange={this.onReferralTypeChange} defaultChecked={isChecked} checked={isChecked} />*/}
                    {/*<span>In-person only</span>*/}
                {/*</div>*/}
                <div className="referral-editor-reason">
                    <TextInput name="referral-reason" value={referralReason} onChange={this.onReferralReasonChange} placeholder={AppPlaceholders.ADDITIONAL_INSTRUCTIONS_EDITVIEW_REASON}/>
                </div>
                <div className="referral-editor-days">
                    <DurationComponent unit={defaultSinceMonth} count={referralDays} rootClass={"referral-days"}
                                       onCountChange={this.onReferralWhenCountChange} onUnitChange={this.onReferralWhenUnitChange}
                                       onDurationChange={this.onReferralWhenChange}/>
                </div>
                {/*{*/}
                    {/*this.props.consultationType === AppConstants.ConsultationTypes.KMH &&*/}
                    {/*<div className="referral-editor-reminder">*/}
                        {/*<input type="checkbox" onChange={this.onReferralReminderChange} checked={reminderStatus} />*/}
                    {/*</div>*/}
                {/*}*/}
            </div>
        );
    }
}

export default DoctorReferralItemEditor;
